export const SET_BRANDS = 'SET_BRANDS'
export const SET_LOADING = 'SET_LOADING'
export const SET_MODELS = 'SET_MODELS'
export const SET_MODEL_LOADING = 'SET_MODEL_LOADING'
export const TOGGLE_BRAND_DETAILS = 'TOGGLE_BRAND_DETAILS'
